import React, { Fragment, useState, useEffect, useContext } from "react";
import { withStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import ModalDialogContext from "../../../../Context/ModalDialog/ModalDialogContext";
import { recordTypes } from "../../../../API/config";
import {
  FilterSideBar,
  LoadingIndicator,
  NoAccessScreen,
} from "../../../../Component";
import { searchLocalRecords } from "../../../../API/Entity";
import { RecordsTable, PageHeader } from "..";
import { getAttributeValue } from "../../../../Utilities/Functions";
import { styles } from "./styles";

const Records = (props) => {
  const { classes, user, hasPermission, hasRecordPermission } = props;

  const [loading, setLoading] = useState(true);
  const [pageNumber, setPageNumber] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(30);
  const [records, setRecords] = useState([]);
  const [fetchData, setFetchData] = useState(true);
  const [totals, setTotals] = useState(0);
  const [canSearch, setCanSearch] = useState();
  const [canView, setCanView] = useState();
  const [canFilterByScore, setCanFilterByScore] = useState();

  const [searchCriteria, setSearchCriteria] = useState();
  const { showErrorMessage } = useContext(ModalDialogContext);

  useEffect(() => {
    setFetchData(true);
  }, []);

  useEffect(() => {
    const evalPermissions = async () => {
      const canSearch = await hasPermission(
        recordTypes.record.name,
        recordTypes.record.actions.search.name,
      );
      setCanSearch(canSearch);
      const canView = await hasPermission(
        recordTypes.record.name,
        recordTypes.record.actions.view.name,
      );
      setCanView(canView);

      const canFilterByScore = await hasPermission(
        recordTypes.record.name,
        recordTypes.record.actions.filterByScore.name,
      );
      setCanFilterByScore(canFilterByScore);
    };

    const loadRecords = async () => {
      setLoading(true);
      try {
        const results = await searchLocalRecords({
          pageNumber: pageNumber,
          rowsPerPage: rowsPerPage,
          searchCriteria,
        });
        const { data } = results || {};
        const { records, totals } = data || {};
        setRecords(records.map(convertToTableData));
        setTotals(totals);
      } catch (error) {
        showErrorMessage({ error });
      }
      setLoading(false);
      setFetchData(false);
    };

    evalPermissions();
    if (fetchData) {
      loadRecords();
    }
  }, [fetchData]);

  if (!loading && !canSearch) {
    return <NoAccessScreen />;
  }

  const handlePagination = async (pageNumber) => {
    setPageNumber(pageNumber);
    setFetchData(true);
  };

  const handleRowsPerPage = async (rows) => {
    setRowsPerPage(rows);
    setFetchData(true);
  };

  const convertToTableData = (record) => {
    let scoreObj = [];
    let attributesObj = [];

    const {
      id,
      entity_category: recordType,
      attributes = [],
      scores = [],
      country,
      permissions,
    } = record;
    if (attributes.length > 0) {
      attributesObj = attributes.reduce(function (attrs, attr) {
        attrs[attr.name] = getAttributeValue(attr);
        return attrs;
      }, {});
    }
    if (scores.length > 0) {
      scoreObj = scores.reduce(function (allScores, scr) {
        allScores[scr.check_type] = {
          value: scr.accepted_score || scr.guided_score,
          validFrom: scr.valid_from_date,
          validTo: scr.expiry_date,
          expired: scr.expired,
        };
        return allScores;
      }, {});
    }
    const canView = hasRecordPermission(
      permissions,
      recordTypes.record.actions.view.name,
    );
    return {
      id,
      recordType,
      name: attributesObj["Full name"],
      country,
      dunsNumber: attributesObj["DUNS number"]
        ? attributesObj["DUNS number"]
        : "-",
      kycScore: scoreObj["KYC"] ? scoreObj["KYC"].value : "No Score",
      kycValidFrom: scoreObj["KYC"] ? scoreObj["KYC"].validFrom : "-",
      kycValidTo: scoreObj["KYC"] ? scoreObj["KYC"].validTo : "-",
      amlScore: scoreObj["AML"] ? scoreObj["AML"].value : "No Score",
      amlValidFrom: scoreObj["AML"] ? scoreObj["AML"].validFrom : "-",
      amlValidTo: scoreObj["AML"] ? scoreObj["AML"].validTo : "-",
      kycExpired: scoreObj["KYC"] ? scoreObj["KYC"].expired : false,
      amlExpired: scoreObj["AML"] ? scoreObj["AML"].expired : false,
      canView,
    };
  };

  const renderLoadingIndicator = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "70vh",
        }}
      >
        <LoadingIndicator />
      </div>
    );
  };

  const renderTable = () => {
    if (loading) {
      return <Fragment>{renderLoadingIndicator()}</Fragment>;
    } else {
      return (
        <RecordsTable
          data={records}
          totalItemsCount={totals.totalCount}
          rowsPerPage={rowsPerPage}
          pageNumber={pageNumber}
          handlePagination={handlePagination}
          handleRowsPerPage={handleRowsPerPage}
          canView={canView}
        />
      );
    }
  };

  const onSearchCriteriaChange = async (newSearchCriteria) => {
    setSearchCriteria({ ...searchCriteria, ...newSearchCriteria });
    setFetchData(true);
  };

  return (
    <Grid container>
      <Grid container className={classes.bodyContainer}>
        <Grid item xs={4} sm={4} md={3} lg={2}>
          <FilterSideBar
            nameFilter={true}
            recordFilter={true}
            countryFilter={true}
            scoreFilter={canFilterByScore}
            checkStatusFilter={true}
            user={user}
            onSearchCriteriaChange={onSearchCriteriaChange}
          />
        </Grid>
        <Grid item xs={8} sm={8} md={9} lg={10}>
          <Grid container>
            <Grid item xs={12}>
              <PageHeader totals={totals} />
            </Grid>
            <Grid item xs={12}>
              {renderTable()}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default withStyles(styles, { withTheme: true })(Records);
